/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home__Hero__PrefixInputs */

const en_home__hero__prefix = /** @type {(inputs: Home__Hero__PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter. Battle. Win.`)
};

/**
* | output |
* | --- |
* | "Enter. Battle. Win." |
*
* @param {Home__Hero__PrefixInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home__hero__prefix = /** @type {((inputs?: Home__Hero__PrefixInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home__Hero__PrefixInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home__hero__prefix(inputs)
});